jq(document).ready(function() {  
    // Add class 'hasMenuSetup' to the header with id 'menu'
    jq("#menu").addClass("hasMenuSetup");
    
    // On click of element with id 'menuTrigger--open', add class 'hasMenuOpen' to header with id 'menu'
    jq("#menuTrigger--open").on("click", function(e) {
        e.preventDefault(); 
        jq("#menu").addClass("hasMenuOpen");
    });
    
    // On click of element with id 'menuTrigger--close', remove class 'hasMenuOpen' from header with id 'menu'
    jq("#menuTrigger--close").on("click", function(e) {
        e.preventDefault(); 
        jq("#menu").removeClass("hasMenuOpen");
    });

    // Match live MainMenu.js: only intercept parent clicks at the mobile menu breakpoint
    // (screen_mobileMenu: 860px). Prevent navigation so the accordion can open instead.
    jq("#menu").on("click", ".node--hasChild > a", function(e) {
        if (!window.matchMedia("(max-width: 861px)").matches) {
            return;
        }

        e.preventDefault();

        var parentNode = jq(this).closest(".node--hasChild");
        var childWrap = jq(this).next(".childWrap");

        if (!childWrap.length) {
            childWrap = parentNode.children(".childWrap").first();
        }

        if (!childWrap.length) {
            return;
        }

        if (childWrap.is(":visible")) {
            childWrap.slideUp(300);
        } else {
            childWrap.slideDown(300);
        }

        parentNode.toggleClass("isOpen");
    });
});
